export default __webpack_public_path__ + "static/IMG_4995-a52efa0ab233c3e798640d576eef3a28.jpg";